import React from 'react'
import I18n from 'APP/I18n'

import { useSelector } from 'APP/Hooks/redux'
import {
  selectExternalClaims,
  selectEpharmacyExternalServicesByProvider,
} from 'APP/Redux/PatientRedux'
import { usePillwayNavigation } from 'APP/Lib/PillwayHelpers'

import ListItem from 'APP/Converse/ListItem'

const PharmacyAccountMenuItem = () => {
  const externalClaims = useSelector(selectExternalClaims)
  const epharmacyPillwayExternalServices = useSelector((state) =>
    selectEpharmacyExternalServicesByProvider(state, 'pillway')
  )
  const navigateToPillway = usePillwayNavigation()

  if (!externalClaims?.sunlife?.access_id) return null

  return (
    <>
      {epharmacyPillwayExternalServices?.map((pharmacy) => (
        <ListItem
          key={`pharmacy-account-${pharmacy.id}`}
          analyticsName="pharmacy-account"
          testID="PHARMACY_ACCOUNT_SCREEN_PHARMACY_MENU_ITEM"
          title={I18n.t('AccountScreen.pharmacyAccount')}
          onPress={() => navigateToPillway(pharmacy)}
        />
      ))}
    </>
  )
}

export default PharmacyAccountMenuItem
